import React from "react"
import styled from "styled-components"
import colors from "@constants/colors"
import breakpoints from "@constants/breakpoints"
import {
  h4Styles,
  h5Styles,
  smallcapsBold13Styles,
} from "@constants/typography"
import TextButton from "@components/buttons/TextButton"
import TextInput from "@components/inputs/TextInput"
import { postSubscribeNewsletter } from "@utils/api"
import { Formik, FormikHelpers as FormikActions } from "formik"
import * as Yup from "yup"

const Form = styled.form`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 334px;
  padding: 0 20px;
  @media ${breakpoints.laptop} {
    flex-direction: row;
    justify-content: space-between;
    padding: 0 calc(2 / 12 * 100vw) 0 calc(1 / 12 * 100vw);
  }
  border-top: 1px solid ${colors.dividerLineGray};
`

const Heading = styled.h4`
  ${smallcapsBold13Styles}
  margin: 0;
  text-align: center;
  margin-bottom: 42px;
  width: 260px;
  @media ${breakpoints.laptop} {
    ${h5Styles}
    flex-shrink: 0;
    text-align: left;
    width: calc(3 / 12 * 100vw);
    margin-right: calc(1 / 12 * 100vw);
  }
  @media ${breakpoints.desktop} {
    ${h4Styles}
    margin-right: calc(1 / 12 * 100vw);
  }
`

const FormSubmit = styled(TextButton)`
  margin-top: 24px;
  padding-top: 4px;
  flex-shrink: 0;
  @media ${breakpoints.laptop} {
    width: calc(1.5 / 12 * 100vw);
    margin-left: calc(1 / 24 * 100vw);
    margin-top: 0;
  }
`

const Field = styled(TextInput)`
  @media ${breakpoints.laptop} {
    transform: translateY(7px);
  }
`

export const EmailSchema = Yup.object().shape({
  email: Yup.string().email("Invalid email").required("Your email is required"),
})

const NewsletterSignup: React.FC = () => {
  const [buttonText, setButtonText] = React.useState("Get it")
  React.useEffect(() => {
    if (buttonText !== "Get it")
      setTimeout(() => {
        setButtonText("Get it")
      }, 3000)
  }, [buttonText])
  const onSubmitEmail = async (
    values: {
      email: string
    },
    formikActions: FormikActions<{
      email: string
    }>
  ) => {
    const data = {
      profiles: [
        {
          email: values.email,
        },
      ],
    }
    await postSubscribeNewsletter(data, () => {
      setButtonText("Invite Sent!")
    })
    formikActions.setSubmitting(false)
    formikActions.resetForm()
  }
  return (
    <Formik
      onSubmit={onSubmitEmail}
      initialValues={{ email: "" }}
      validationSchema={EmailSchema}
      validateOnBlur={false}
      validateOnChange={false}
      render={({ values, errors, handleChange, handleBlur, handleSubmit }) => (
        <Form onSubmit={handleSubmit}>
          <Heading>Keep in touch with our monthly newsletter</Heading>
          <Field
            type="email"
            name="email"
            placeholder={"Email"}
            onChange={handleChange}
            onBlur={handleBlur}
            value={values.email}
            error={errors.email !== undefined}
          />
          <FormSubmit text={buttonText} />
        </Form>
      )}
    />
  )
}

export default NewsletterSignup
